export default __webpack_public_path__ + "static/media/toilet-accessible.inline.d9552f34.svg";